import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing8 } from 'approot/shared/styles/spacing.style';
import { font20 } from 'approot/shared/styles/typography.style';
import { LinkButton } from 'approot/shared/styles/buttons/link-button.style';
import { baseFlexCss } from 'approot/shared/styles/flex.style';

type DiscussionAnswerLinkProps = {
  $marginBottom?: number;
};
export const DiscussionAnswerLink = styled(
  LinkButton
)<DiscussionAnswerLinkProps>`
  ${font20}
  ${baseFlexCss}
  margin-top: ${rem(spacing8)};
  ${({ $marginBottom }) =>
    $marginBottom && `margin-bottom: ${rem($marginBottom)}`};
`;
